import React, { Component } from 'react';

import Licenses from './LicensesComponent';
import { actions } from './LicensesReducer';
import { connect } from 'react-redux';

class Wrapper extends Component {
    componentDidMount() {
        this.props.fetch(this.props.isSaaS);
    }
    
    render() {
        return (
            <React.Fragment>
                <Licenses {...this.props} />                
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        licenses: state.waas.licenses.fetcher.items || [],
        isSaaS: state.waas.licenses.licenses.isSaaS,
        itemsPerPage: state.waas.licenses.fetcher.itemsPerPage,
        itemsTotal: state.waas.licenses.fetcher.itemsTotal,
        pageNumber: state.waas.licenses.fetcher.page,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        fetch: (val) => dispatch(actions.trigger({isSaaS:val})),
        setSaaS: (val) => dispatch(actions.setSaaS(val)),
        changeitemsPerPage: (val) => dispatch(actions.changeitemsPerPage(val)),
        pageChange: (val) => dispatch(actions.pageChange(val)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper)